// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../dist/gui.d.ts" />
import { GifFrames } from "../src/utils/GifFrames"
export default class TestImage {

    public constructor(app: vf.Application, uiStage: vf.gui.Stage) {
        this.onLoad(app, uiStage)
    }
    private _TestImage?: vf.gui.Image;
    private source: any;
    private _buttonList: vf.gui.Label[] = [];
    private async onLoad(app: vf.Application, uiStage: vf.gui.Stage) {

        // await vf.utils.readFileSync('https://s.vipkidstatic.com/vf/plugin/FilterColorMatrix/0.0.3.js',{moduleName:'ColorMatrixFilter'});
        // await vf.utils.readFileSync('https://s.vipkidstatic.com/vf/plugin/FilterRadialBlur/0.0.1.js',{moduleName:'RadialBlurFilter'});
        // await vf.utils.readFileSync('https://s.vipkidstatic.com/vf/plugin/FilterGodray/0.0.1.js',{moduleName:'GodrayFilter'});

        // //灰色
        // const img1 = new vf.gui.Image();
        // img1.style.left = 15;
        // img1.style.top = 15;
        // img1.style.width = 340;
        // img1.style.height = 160;
        // img1.src = "assets/mask/bg.jpg";
        // // img1.filter.ColorMatrixFilter._sepia = true;
        // // img1.filter.RadialBlurFilter.angle = 20;
        // // img1.filter.GodrayFilter.angle = 30;
        // // img1.filter.GodrayFilter.center = [100,-100];
        // // img1.filter.GodrayFilter.gain = 0.48;
        // // img1.filter.GodrayFilter.lacunarity = 2.8;
        // // img1.filter.GodrayFilter.parallel = true;
        // // img1.filter.GodrayFilter.time = 0;
        // uiStage.addChild(img1);

        // //彩色
        // const img2 = new vf.gui.Image();
        // img2.style.left = 15;
        // img2.style.top = 15;
        // img2.style.width = 340;
        // img2.style.height = 160;
        // img2.style.maskImage = "assets/mask/clear1.png";
        // img2.style.maskSize = [340, 160];
        // img2.style.maskPosition = [-70, -70];
        // img2.src = "assets/mask/bg.jpg";
        // img2.visible = false;
        // uiStage.addChild(img2);


        // let count = 0;
        // vf.gui.TickerShared.add(() => {

        //     if (count == 700) {
        //         count = 0;
        //     }
        //     if (img2.style.maskSize && img2.style.maskSize[0] < 1200) {
        //         img2.style.maskSize = [count, count];
        //         //img1.filter.RadialBlurFilter.angle--;
        //         img1.filter.GodrayFilter.time += 0.01;
        //         img1.filter.GodrayFilter.gain += 0.01;
        //         img1.filter.GodrayFilter.lacunarity += 0.01;
        //     }
        //     count += 1;
        // }, this);
        // vf.Loader.registerPlugin({
        //     use: this.gifParser
        // });
        // this.insertGifParser(vf.Loader.shared);
        const a = new vf.Loader();
        let img3: any;
        const url = 'https://test-ic-static.vipkid.com.cn/course/materialVIPKIDKB/MVP01-L7-U1-LC1-30/39b0d9069b9cf6c44667e18bff3daeca_6045f06fb2f511eb91fa11c597421a75.gif'//?x-oss-process=image/resize,p_80/quality,Q_90/format,webp&imageMogr2/thumbnail/!80p/rquality/90/format/webp'//"22.gif";
        a.add({ url: url, loadType: vf.LoaderResource.LOAD_TYPE.XHR, xhrType: 'arraybuffer' });// "./5-140FGZ251.gif" },

        a.load();
        a.onComplete.add((resources) => {
            const resource = resources.resources[url];
            this.source = resource;
            img3 = new vf.gui.Image();
            img3.src = resource;
            img3.x = 300;
            img3.y = 400;
            uiStage.addChild(img3);
            console.error(" 加载完成", img3);
        }, this);

        // const img3 = this._TestImage = new vf.gui.Image();
        // img3.x = uiStage.width >> 1;
        // img3.y = 100;
        // img3.src = "assets/dino.png";
        // uiStage.addChild(img3);

        //uiStage.extractBase64(img3)

        const con = new vf.gui.Container();
        uiStage.addChild(con);

        const imgr = this._TestImage = new vf.gui.Image();
        imgr.x = uiStage.width >> 1;
        imgr.y = 100;
        con.addChild(imgr);

        setTimeout(() => {
            //imgr.src = uiStage.screenShots(0, 0, 500, 500);
        }, 1000);


        const rect = new vf.gui.Rect();
        rect.color = 0xffffff;
        rect.lineColor = 0xff00cc;
        rect.lineWidth = 1;
        rect.radius = 10; //圆角
        this.getButton('设置/取消tint', () => {
            if (img3.tint !== 0xcc0000) {
                img3.tint = 0xcc0000;
            } else {
                img3.tint = 0xffffff;
            }

        }, uiStage, 15, 0);


        this.getButton('设置/取消scale', () => {
            if (img3.scaleX !== 2) {
                img3.scaleX = 2;
                img3.scaleY = 2;
            } else {
                img3.scaleX = 1;
                img3.scaleY = 1;
            }

        }, uiStage, 15, 0);

        this.getButton('设置/取消width,height', () => {
            if (img3.width !== 200) {
                img3.width = 200;
                img3.height = 200;
                console.log('立即获取宽度:', img3.width);
                setTimeout(() => {
                    console.log('延迟宽度获取:', img3.width);
                }, 300);
            } else {
                img3.width = NaN;
                img3.height = NaN;
                console.log('立即获取宽度:', img3.width);
                setTimeout(() => {
                    console.log('延迟宽度获取:', img3.width);
                }, 300);
            }
        }, uiStage, 15, 0);

        this.getButton('设置/取消fillMode', () => {
            if (img3.fillMode !== 'repeat') {
                img3.fillMode = "repeat";
                img3.width = 200;
                img3.height = 200;
                img3.scale9Grid = [1.2, 1.5, -50, -50];
            } else {
                img3.width = NaN;
                img3.height = NaN;
                img3.fillMode = 'no-repeat';
            }
        }, uiStage, 15, 0);

        this.getButton('设置/取消fillMode - repeat - scale9', () => {
            if (img3.scale9Grid === undefined) {
                img3.fillMode = "repeat";
                img3.width = 200;
                img3.height = 200;
                img3.scale9Grid = [1.2, 1.5, -50, -50];
            } else {
                img3.width = NaN;
                img3.height = NaN;
                img3.scale9Grid = undefined;
            }
        }, uiStage, 15, 0);

        this.getButton('设置/取消fillMode - scale - scale9', () => {
            if (img3.scale9Grid === undefined) {
                img3.fillMode = "scale";
                img3.width = 200;
                img3.height = 200;
                img3.scale9Grid = [10, 10, 60, 10];
            } else {
                img3.width = NaN;
                img3.height = NaN;
                img3.scale9Grid = undefined;
            }
        }, uiStage, 15, 0);

        this.getButton('设置/取消maskImage -> displayObject', () => {
            if (img3.style.maskImage) {
                img3.style.maskImage = undefined;
            } else {
                img3.style.maskImage = rect;
                img3.style.maskSize = [100, 50];
                img3.style.maskPosition = [0, 20]; //如果没有添加到舞台，坐标按当前父级算
            }
        }, uiStage, 15, 0);

        this.getButton('设置/取消maskImage -> url', () => {
            if (img3.style.maskImage) {
                img3.style.maskImage = undefined;
            } else {
                img3.style.maskImage = 'assets/btnbg.png';
                img3.style.maskSize = [50, 50];
                img3.style.maskPosition = [0, 20]; //如果没有添加到舞台，坐标按当前父级算
            }
        }, uiStage, 15, 0);

        this.getButton('设置/取消anchorX,anchorY', () => {
            if (img3.anchorX === 0.5) {
                img3.anchorX = 0;
                img3.anchorY = 0;
                img3.rotation = 0;
                img3.style.backgroundColor = undefined;
            } else {
                img3.anchorX = 0.5;
                img3.anchorY = 0.5;
                img3.style.backgroundColor = 0xffffff;
                vf.gui.Tween.to(img3, { rotation: 360 }, 1000).start();
            }
        }, uiStage, 15, 0);

        this.getButton('设置/还原src', () => {
            if (img3.src == 'assets/dino.png') {
                img3.src = this.source;
            } else {
                img3.src = 'assets/dino.png';
            }
        }, uiStage, 15, 0);

        this.getButton('设置base64', () => {
            img3.src = 'data:image/gif;base64,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';
        }, uiStage, 15, 0);

        this.getButton('设置/清空src, src=""', () => {
            if (img3.src == 'assets/dino.png') {
                img3.src = '';
            } else {
                img3.src = 'assets/dino.png';
            }
        }, uiStage, 15, 0);


    }

    private insertGifParser(loader: vf.Loader): void {
        if (loader) {
            loader.use(this.gifParser);
        }
    }

    private onHover(e: vf.gui.Interaction.InteractionEvent, button: vf.gui.Button, over: boolean) {
        console.log("onHover", over);
        if (over)// eslint-disable-next-line @typescript-eslint/no-explicit-any
            button.text = "移入" + (e as any).type;
        else// eslint-disable-next-line @typescript-eslint/no-explicit-any
            button.text = "移出" + (e as any).type;
    }

    private posY = 10;
    private getButton(title: string, fun: Function, target: any, x: number, y: number) {
        const button = new vf.gui.Label;
        button.style.fontSize = 24;
        button.style.fontFamily = 'PingFang-SC-Medium,PingFang-S';
        button.style.fontWeight = 500;
        button.style.color = 0xffffff;
        button.style.lineHeight = 45;
        button.text = title;
        button.interactabled = true;
        button.x = x;
        button.y = this.posY;
        button.on(vf.gui.Interaction.TouchMouseEvent.onClick, fun);
        target.addChild(button);
        this.posY = this.posY + 25 + y;
        this._buttonList.push(button);
    }
    private onRelease() {
        if (this._TestImage) {
            this._TestImage.removeAllListeners();
            this._TestImage.parent && this._TestImage.parent.removeChild(this._TestImage);
            this._TestImage.release();
            this._TestImage = undefined;
        }
        if (this._buttonList && this._buttonList.length > 0) {
            this._buttonList.forEach(element => {
                element.removeAllListeners();
                element.parent && element.parent.removeChild(element);
                element.release();
            });
            this._buttonList = [];
        }
    }
    private gifParser(resource: vf.LoaderResource, next: () => void) {
        if (resource.data && resource.extension == 'gif') {
            const frames = new GifFrames(resource);
            // eslint-disable-next-line no-debugger
            // debugger;

            (resource as any)['frames'] = frames;
            resource.texture = frames.getFrame(0).texture;
        }
        next();
    }
}
